import {
    axiosWithTokenRefresh,
    finalizeResponse,
    handleError,
    API_ERRORS,
} from 'tradera/utils/api';
import { toLocalizedUrl } from 'tradera/utils/url';

export const getTraderaShopProductData = async (id, preferredLanguageCode) => {
    return axiosWithTokenRefresh()
        .get(toLocalizedUrl(`/tradera-shop/${id}.json`, preferredLanguageCode))
        .then(finalizeResponse())
        .then((response) => response.data)
        .catch(
            handleError({
                // Ignore 400 & 401 errors that slip through token refresh
                400: API_ERRORS.IGNORE_ME,
                401: API_ERRORS.IGNORE_ME,
            }),
        );
};
